
export const addEvent = function (cat, action, label) {
    var type = typeof _gaq;
    if (type != "undefined") {
        LOAD_CLSFD_PAP && _gaq.push(['_setCustomVar', 1, 'qh_postad_new', 3]);
        _gaq.push(['_trackEvent', cat, action, label]);
    }
};
export const addPageView = function (url) {
    var type = typeof _gaq;
    if (type != "undefined") {
        LOAD_CLSFD_PAP && _gaq.push(['_setCustomVar', 1, 'qh_postad_new', 3]);
        _gaq.push(['_trackPageview', url]);
    }

};

window.addEventListener("DOMContentLoaded", () => {

    let elements = document.querySelectorAll('[ga-directive]');
    
    elements.forEach((element) => {
        let gaOptions = eval('(' + element.getAttribute('ga-options') + ')');
        switch (element['nodeName'].toLowerCase()) {
            case 'button':
            case 'li':
            case 'span':
            case 'a':
            case 'b':
            case 'small':
            case 'textsarea':
            case 'div':
                element.addEventListener('click',() =>{
                    if ("undefined" != typeof _gaq) {
                        _gaq.push(['_trackEvent', gaOptions.category, gaOptions.action, gaOptions.label]);
                    }
                });
                break;

            case 'input':
                element.addEventListener('click',() =>{
                    if (element['checked']) {
                        if ("undefined" != typeof _gaq) {
                            _gaq.push(['_trackEvent', gaOptions.category, gaOptions.action, gaOptions.label]);
                        }
                    }
                    else
                    {
                        if ("undefined" != typeof _gaq) {
                            _gaq.push(['_trackEvent', gaOptions.category, gaOptions.action, gaOptions.label]);
                        }

                    }
                });
                break;
        }
    })
    
})